export enum SampleStatus {
    Normal = 'normal',
    Removed = 'removed'
}

export enum SampleRequestStatus {
    Normal = 'normal',
    Resolved = 'resolved',
    Removed = 'removed'
}

export interface Sample {
    id: number;
    name: string;
    manufacturer: string;
    catalog: string;
    price: number;
    recommended: boolean;
    createTime: string;
    requestTimes: number;
}

export interface SampleRequest {
    id: number;
    name: string;
    manufacturer: string;
    customerEmail: string;
    customerPhone: string;
}
